import { useAllContactsQuery } from "@codegen/index";
import { useMemo } from "react";
import { Combobox } from "./combobox";

const UserSelector = (props: {
  selectedId?: string;
  onSelect?: (type: string) => void;
  className?: string;
  disabled?: boolean;
}) => {
  const { selectedId, onSelect, disabled } = props;
  const { data } = useAllContactsQuery({ pollInterval: 10000 });

  const opts = useMemo(() => {
    const opts = [];

    for (const contact of data?.allUsers?.nodes ?? []) {
      if (contact == null) continue;
      opts.push({
        value: contact.id ?? "",
        label: contact.fullName,
      });
    }
    return opts;
  }, [data?.allUsers?.nodes]);

  return (
    <Combobox
      options={opts}
      defaultValue={(selectedId as string) ?? ""}
      onSelect={(e) => onSelect?.(e)}
      placeholder="Search user"
      className={props.className}
      disabled={disabled}
    />
  );
};

export default UserSelector;
